import api from "@/api/index";

/**
 * Fetches the list of veterinarians for the logged-in délégué
 * @returns {Promise<Array>} API response containing the list of veterinarians
 */
export async function getVeterinarians() {
  try {
    const response = await api.get("/customers/delegues/veterinaire?page=1&itemsPerPage=9999");
    const veterinarians = Array.isArray(response.data) ? response.data : [];
    return veterinarians.map(vet => ({
      ...vet,
      id: vet.id || `${Date.now()}-${Math.random()}`, // Fallback ID if not provided
      fullName: vet.fullName || "N/A",
      email: vet.email || "N/A",
      gender: vet.gender || "Inconnu",
    }));
  } catch (error) {
    console.error("Error fetching veterinarians:", error);
    throw error.response?.data?.message || "Failed to fetch veterinarians.";
  }
}
